import React from 'react';

const FullPageLoader = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/60 backdrop-blur-sm">
      <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin shadow-lg" />
      <div className="mt-4 absolute bottom-20 text-sm font-medium text-gray-700">Loading...</div>
    </div>
  );
};

export default FullPageLoader;
